// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"08b52b7a","453":"167ce2fd","455":"d0cbaaa5"}[chunkId] + ".chunk.js";
};